import { NAV_ITEMS, type NavItem } from "./navCatalog.generated";

/** Même règle que NavCatalog::findByPath (PHP) : query et fragment ignorés, slash final ajouté. */
export function normalizeNavPath(path: string): string | null {
  const stripped = path.replace(/[?#].*$/s, "");
  if (!stripped.startsWith("/") || stripped.startsWith("//")) return null;
  return stripped.endsWith("/") ? stripped : `${stripped}/`;
}

export function findNavItem(path: string | null | undefined): NavItem | null {
  if (!path) return null;
  const normalized = normalizeNavPath(path);
  return normalized ? NAV_ITEMS.find((item) => item.path === normalized && item.anchor === null) ?? null : null;
}
